import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { listsMatch } from '../../helpers/helpers';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { EntitySelectorData, EntitySelectorDialogComponent } from 'src/app/components/entities/entity-selector.dialog.component';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { Dictionary } from '@ngrx/entity';
import { Performer } from 'src/app/store/performers.era';
import { Sponsor } from 'globals/store/sponsors.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Attendee } from 'globals/store/attendees.data';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { TagPanelData, TagType } from 'globals/store/tags.data';
import { EntityName } from 'globals/store/entity.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiResource } from 'globals/store/resources.data';
import { TagPanelViewComponent } from './tag-panel-view.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'tag-panel',
    template: `
<tag-panel-view
  [tagData]="tagData"
  [readOnly]="readOnly"
  [noHeaders]="noHeaders"
  [fromLogistics]="fromLogistics"
  [performers]="performers"
  [sponsors]="sponsors"
  [exhibitors]="exhibitors"
  [resources]="resources"
  [workforce]="workforce"
  [attendees]="attendees"
  (removeTag)="removeTag.emit($event)"
  (setTags)="setTags.emit($event)"
  (openTagger)="openTagger($event.event, $event.tagType)"
></tag-panel-view>
`,
    standalone: true,
    imports: [TagPanelViewComponent, CommonModule],
})
export class TagPanelComponent extends Wrapper<TagPanelComponent> {
  @Input() tagData: TagPanelData
  @Input() readOnly = false
  @Input() noHeaders = false
  @Input() fromLogistics: boolean = false
  @Output() removeTag: EventEmitter<{ tagType: TagType, id: string }> = new EventEmitter()
  @Output() setTags: EventEmitter<{ tagType: TagType, ids: string[] }> = new EventEmitter()

  performers: Dictionary<Performer>
  sponsors: Dictionary<Sponsor>
  exhibitors: Dictionary<Exhibitor>
  resources: Dictionary<JoiResource>
  workforce: WorkerWithProfile[]
  attendees: Dictionary<Attendee>

  constructor() {
    super()
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')
    this.subProp(this.store.select('exhibitors', 'entities'), 'exhibitors')
    this.subProp(this.store.select('resources', 'entities'), 'resources')
    this.subProp(this.store.select('attendees', 'entities'), 'attendees')
    this.subCallback(this.store.select('workforce', 'workforce'), workforce => {
      this.workforce = jsonCopyObject(workforce)
      this.workforce.forEach(w => {
        const { email, firstName: f, lastName: l } = w
        w.name = `${f || ''}${f && l ? ' ' : ''}${l || ''}`
        w.id = email
      })
    })
  }

  async openTagger(event: Event, tagType: TagType) {
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const selectedEntities = {}
    

    let preTaggedIds, entities
    switch (tagType) {
      case 'attendee':
        preTaggedIds = this.tagData.attendeeTags.map(t => t.id)
        entities = Object.values(this.attendees)
        break
      case 'performer':
        preTaggedIds = this.tagData.performerTags.map(t => t.id)
        entities = Object.values(this.performers)
        break
      case 'workforce':
        preTaggedIds = this.tagData.workforceTags.map(t => t.id)
        entities = Object.values(this.workforce)
        break
      case 'sponsor':
        preTaggedIds = this.tagData.sponsorTags.map(t => t.id)
        entities = Object.values(this.sponsors)
        break
      case 'exhibitor':
        preTaggedIds = this.tagData.exhibitorTags.map(t => t.id)
        entities = Object.values(this.exhibitors)
        break
      case 'resource':
        preTaggedIds = this.tagData.resourceTags.map(t => t.id)
        entities = Object.values(this.resources)
        break
      default:
        console.log("Missing pre tagged ids logic for " + tagType)
        return
    }
    entities.forEach(e => selectedEntities[e.id] = preTaggedIds.includes(e.id))

    const data: EntitySelectorData = { 
      tagOnly: true,
      selectedEntities,
      entities, 
      searchPlaceholder: 'Search ' + (tagType === 'workforce' ? 'workforce' : `${tagType}s`), 
      entityName: tagType[0].toUpperCase() + tagType.slice(1) as EntityName,
      rect,
      entityHolderName: tagType.toUpperCase()
    }
    console.log(data)

    await openDialogGetResult<Promise<string[]>>(this.dialog, EntitySelectorDialogComponent, { width: '300px', data, disableClose: false, backdropClass: 'clear' })
    const selected = Object.entries(selectedEntities).filter(([_, ticked]) => ticked).map(([id, _]) => id)
    if (listsMatch(selected, preTaggedIds)) return

    console.log({ selected, tagType })
    this.setTags.emit({ tagType, ids: selected })
  }

}



